import { Constants } from './v2-fgen-constants.js';
import { FEngineException, FE$OptionHelper } from './v2-fgen-fengine.js';

// Legacy compatibility
const FE_BaseRenderer = function () {

    // private
    let _proxy, _wrapper, _container, _def, _errorLbl, _lang, _isVisible = true;

    //public
    return Object.assign({}, {
        nature: function () { return 'renderer' },
        lock: doLock => { },  // Empty by default
        isValid: function () {
            let error = _proxy.validate(this.getValue(), this.getType(), this.getVariant(), _def.validators, _lang);
            this.toggleInvalid(error != null, error);

            // TODO: This must be revised
            // This method is called by engine and it expects NULL for VALID components
            return error;
        },
        getValue: function () { throw new FEngineException('getValue not defined on renderer') },
        _getValue: function () {
            // TODO: as said in isValid method , this must be revised
            // isValid should return true when the value is valid instead of NULL
            if (this.isValid() == null) {
                return this.getValue();
            }
            return null;
        },
        setValue: function (v) { console.warn('[FER] ERROR: Not implemented setValue on ' + _def.type + '. Attempted setting value ' + v) },
        getType: function () { throw new FEngineException('getType not defined on renderer') },
        getVariant: function () { return 'raw' },
        _translateTo: function (lang) {
            while (_errorLbl.hasChildNodes()) {
                _errorLbl.removeChild(_errorLbl.firstChild);
            }
            _container && _container.classList.remove('error');
            _lang = lang;
            this.translateTo(lang)
        },
        translateTo: function (lang) { },
        isValueControl: function () { return true },
        isFileControl: function () { return false },
        setProxy: function (p) { _proxy = p },
        getProxy: function () { return _proxy },
        onEvent: function (event, data, control) { console.log('[fe$BR] Detected event ' + event + ' on ' + control) },
        getLanguage: function () { return _lang },
        isVisible: function () { return _isVisible },
        setVisible: function (visible, freeSpace) {
            _isVisible = visible;
            if (freeSpace) { // this is legacy code
                _container.parentNode.style.display = visible ? 'inline-block' : 'none';
            } else {
                _container.style.visibility = visible ? 'visible' : 'hidden';
            }
        },
        getDefaultLanguage: function () { return _proxy ? _proxy.defaultLang : null }, //This may return 'es' if null 
        notifyChange: function () { _proxy && _proxy.onEvent(getProxy().Events.CHANGE, _def.name) },
        subscribeToChangesOn: function (who) { _proxy.subscribeTo(getProxy().Events.CHANGE, who, _def.name) },
        getValueOf: function (who) { return _proxy ? _proxy.getValueOf(who) : null },
        getDefinition: function () { return _def },
        getElement: function () { return _container },
        getTranslator: function () { return _proxy.translate },
        forceWidth: function (w) { return _wrapper && (_wrapper.style.width = w) },
        getDataProvider: function () {
            if (!_proxy) {
                throw new FEngineException("No data provider available");
            }
            return _proxy.queryData;
        },
        toggleInvalid: function (invalid, message) {
            _wrapper && _wrapper.classList.remove('error');
            while (_errorLbl.hasChildNodes()) {
                _errorLbl.removeChild(_errorLbl.firstChild);
            }
            if (invalid) {
                _errorLbl.appendChild(document.createTextNode(message));
                _wrapper && _wrapper.classList.add('error');
            }
        },
        _render: function (def, where, lang) {
            console.log('[FER] Called inner render with definition: ' + JSON.stringify(def));

            _def = def;
            _lang = lang;
            _wrapper = document.createElement('div');
            _wrapper.setAttribute('class', 'FE-wrapperR '
                + (this.isValueControl() ? ' FE-valueWrapperR' : '')
                + ' FE-' + this.getType() + 'WrapperR'
                + ' FE-' + this.getType() + this.getVariant() + 'WrapperR'
                + (def.cssClass ? ' ' + def.cssClass : '')
            );
            _container = document.createElement('div');
            _container.setAttribute('class', 'FE-controlR'
                + ' FE-' + this.getType()
                + ' FE-' + this.getType() + '-' + this.getVariant()
            );
            _wrapper.appendChild(_container);

            _errorLbl = document.createElement('label');
            _errorLbl.setAttribute('class', 'FE-controlR-error FE-' + this.getType() + '-error');

            def.width && forceWidth(def.width);

            where.appendChild(_wrapper);
            this.render(_container, lang)
            _container.appendChild(_errorLbl);
        },
        render: function (where, lang) { throw new FEngineException('render not defined on renderer') },
    });
}

function FE$MultiLevelChoiceRenderer() {
    //This component only works with two levels depth instead of N levels because the html provided only was thinked to work with two levels

    //private:
    let container, index, elements;
   
    // Object composition
    return Object.assign(FE_BaseRenderer(), {
        getType: function () { return 'multilevelchoice' },
        getValue: function () {
            let ret = {}
            ret[''] =  elements.map(element => element.firstLevelCBX).filter(pcb => Boolean(pcb?.value) && pcb.checked).map(pcb => pcb.value).join(',');
            ret.array = [];
           
            container.querySelectorAll('input:not(.input-all)').forEach(checkbox => 
                checkbox?.checked 
                && ret.array.push({ "value": checkbox.value }))
      
            // TODO: This weird thing is for legacy compatibility and must be revised in the future
            return ret;
        },
        _onOptionsReady: function (data, isFull) {
            let def = this.getDefinition();

            console.log('[feSCR] Obtained options for ' + def.name + ' and data: ' + JSON.stringify(data));
            if (!data) return;

            this._drawComponent(data)
            
            if(++index == this.getDefinition().options.datasource.split(',').length){
                this._setListeners(def)
                this.getElement().classList.remove('loading')
            }
        },
        _setListeners: function(def) {
            for(let i = 0; i < index;i++){
                let sectionId = def.name + i;
                let thisSection = document.getElementById(sectionId)
                let arrow = document.getElementById('accordionArrow'+i)
                let element = {
                    firstLevelContainer : thisSection.querySelector('.Checkbox-parent'),
                    firstLevelCBX : thisSection.querySelector('.Checkbox-parent').querySelector('input.form-checkbox'),
                    secondLevelContainer : thisSection.querySelector('.accordion-panel'),
                    secondLevelCBX : thisSection.querySelector('.accordion-panel').querySelectorAll('input.form-checkbox'),
                    allCheckbox : thisSection.querySelector('.Checkbox-child input.form-checkbox:first-child')
                }
                

                //Open/close component
                arrow.addEventListener('click', (e) => {
                    if (arrow.classList.contains('down')) {
                        //open accordion
                        arrow.classList.replace('down', 'up');
                        element.firstLevelContainer.classList.add('accordion--active');
                        element.secondLevelContainer.style.maxHeight = 'fit-content';
                    } else {
                        //close accordion
                        arrow.classList.replace('up', 'down');
                        element.firstLevelContainer.classList.remove('accordion--active');
                        element.secondLevelContainer.style.maxHeight = '0px';
                    }
                });

                // Select firstLevel checkbox
                element.firstLevelContainer.addEventListener('change', (e) => {
                    if (!e.currentTarget.checked) {
                        element.secondLevelCBX
                            .forEach(cb => cb.checked = false);
                    }
                });

                // Select allCheckbox
                element.allCheckbox.addEventListener('change', (e) => {
                        //Check all the child list
                        element.secondLevelCBX.forEach(cb => cb.checked = e.currentTarget.checked);
                        //And the main too    
                        element.firstLevelCBX.checked = e.currentTarget.checked;
                    
                });

                // Select second Level
                element.secondLevelCBX.forEach(cb=>
                 //  cb.addEventListener('change', this._onOptionChanges.bind(this))
                 cb.addEventListener('change', (e) =>{
                    if (e.currentTarget.checked) {
                        element.firstLevelCBX.checked = true;
                        if (Array.from(element.secondLevelCBX).every(i => i.classList.contains('input-all') || i.checked)) {
                            element.secondLevelContainer.querySelector('.input-all').checked = true;
                        }
                    } else {
                        element.secondLevelContainer.querySelector('.input-all').checked = false;
                    }
                 })
                )
                elements.push(element)
            }
            
        },
        _onOptionChanges: function (e) {
            console.log('Changes! ', e);
            let index = e.currentTarget.parentElement.parentElement.parentElement.parentElement.id.slice(9);
            if (e.currentTarget.checked) {
                firstLevelContainer[index].querySelector('input.form-checkbox').checked = true;
                if (Array.from(secondLevelContainer[index].querySelectorAll('input.form-checkbox')).every(i => i.classList.contains('input-all') || i.checked)) {
                    secondLevelContainer[index].querySelector('.input-all').checked = true;
                }
            } else {
                secondLevelContainer[index].querySelector('.input-all').checked = false;
            }
        },
        _refresh: function (def) {
            console.log('[feSC] refresh multilevelchoice');
            this.getElement().classList.add('loading');
            this._value = null;
            this._options = [];
            this._opSelection = {};
            container.innerHTML = '';
            elements = []
            index = 0

            this._optionHelper.getOptions(this.getLanguage(), this._onOptionsReady.bind(this));
        },

        translateTo: function (lang) {
            console.log("Someone is calling lang");
            this.render(container, lang);
        },
        render: function (where, lang) {
            container = where;
            
            this._options = [];
            this._opSelection = {};
 
            let def = this.getDefinition();
         
            this._optionHelper = new FE$OptionHelper(def, this.getProxy(), null, def.sort !== false);
            this._optionHelper.getDependencies().forEach(d => this.subscribeToChangesOn(d));
            this._refresh(def);
        },
        _drawComponent(data){
            let def = this.getDefinition();
            let sectionId = def.name + index;

            //Main checkbox
            let parentRecord = data.find(o => o.parent == null);
            let tabIndex = -1;
            if(def.tabIndex)
                tabIndex = def.tabIndex + (index > 0 ? 1 : 0)
            //@todo - con el multi-datasource no es posible implementar el tabindex => def.tabIndex <input tabindex="'+def.tabIndex+'" - SF_A-5114
            container.innerHTML += '<section id="'+ sectionId + '" class="Wrapper">\
            <div class="Checkbox-parent accordion form__listcat">\
                <input tabindex="'+tabIndex+'" class="form-checkbox " type="checkbox" data-target="#child-inputs" value="' + parentRecord.value + '">\
                <label class="form__listcat_label">' + parentRecord.label + '</label>\
                <i id="accordionArrow' + index + '" class="accordionClick arrow down"></i>\
            </div>\
            <div class="accordion-panel">\
                <ul class="Checkbox-child list-unstyled" >\
                    <li class="d-flex align-items-center py-1">\
                        <input tabindex="' + (++tabIndex) +'" class="form-checkbox input-all" type="checkbox">\
                        <label class="form__listcat_label">' + Constants.CHECKBOX_CHECKALL[this.getLanguage()] + '</label>\
                    </li>\
                </ul>\
            </div>\
            </section>';

           
            //Second Level checkbox
            let listContainer = document.getElementById(sectionId).querySelector('.accordion-panel').querySelector("ul");

            data.filter(o => o.parent == parentRecord.id).forEach(o => {
                let oLi = document.createElement('li');
                oLi.classList.add('d-flex', 'align-items-center', 'py-1');

                let cb = document.createElement('input');
                cb.type = 'checkbox';
                cb.name = def.name;
                cb.value = o.value;
                cb.tabIndex = ++tabIndex
                cb.classList.add('form-checkbox');

                let lb = document.createElement('label');
                lb.classList.add('form__listcat_label');
                lb.innerHTML = o.label;

                oLi.appendChild(cb);
                oLi.appendChild(lb);
                listContainer.appendChild(oLi);
            });
            def.tabIndex = tabIndex
        }
    });
}

export { FE$MultiLevelChoiceRenderer };